<div class="flex h-screen overflow-hidden bg-[#f5f6f7] dark:bg-(--bg-app)">

  <!-- Global API Loader -->
  @if (loaderService.isLoading()) {
    <progress class="progress progress-success w-full fixed top-0 left-0 z-100 h-1 rounded-none bg-transparent"></progress>
  }

  <!-- Desktop sidebar -->
  <app-sidebar
    [collapsed]="sidebarCollapsed()"
    [isModalOpen]="false"
    (onToggleCollapsed)="toggleCollapsed()"
    (onLogout)="handleLogout()"
  />

  <!-- Mobile sidebar -->
  <app-sidebar
    [mobile]="true"
    [open]="sidebarOpen()"
    (onClose)="sidebarOpen.set(false)"
    (onLogout)="handleLogout()"
  />

  <!-- Main content area -->
  <div class="relative flex flex-1 flex-col overflow-hidden min-w-0">

    <!-- Top header — GoSkaler style -->
    <header class="relative z-10 flex h-[56px] shrink-0 items-center justify-between border-b border-gray-100 bg-white px-5 dark:border-(--border-primary) dark:bg-[color-mix(in_srgb,var(--bg-app)_78%,transparent)]">

      <!-- Mobile menu toggle (visible only on mobile) -->
      <button
        class="flex size-8 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-colors xl:hidden dark:text-(--text-secondary) dark:hover:bg-(--button-ghost-hover) dark:hover:text-(--text-primary)"
        (click)="toggleSidebar()"
        aria-label="Abrir menú"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="4" y1="12" x2="20" y2="12"/>
          <line x1="4" y1="6" x2="20" y2="6"/>
          <line x1="4" y1="18" x2="20" y2="18"/>
        </svg>
      </button>

      <!-- Spacer -->
      <div class="flex-1"></div>

      <!-- Right actions -->
      <div class="flex items-center gap-2">

        <!-- Theme toggle -->
        <button
          (click)="themeService.toggle()"
          class="flex size-8 items-center justify-center rounded-lg border border-gray-100 bg-white text-gray-500 transition-all hover:bg-gray-100 hover:text-gray-900 dark:border-(--border-secondary) dark:bg-(--bg-elevated) dark:text-(--text-primary) dark:hover:bg-(--bg-surface-hover)"
          [attr.aria-label]="themeService.isDark() ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'"
        >
          @if (themeService.isDark()) {
            <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.42 1.42M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.42"/>
            </svg>
          } @else {
            <svg aria-hidden="true" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"/>
            </svg>
          }
        </button>

        <!-- User avatar -->
        <app-user-avatar></app-user-avatar>

      </div>
    </header>

    @if (accessIssue()) {
      <div class="absolute left-4 right-4 top-[72px] z-30 flex items-center justify-between gap-4 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950 shadow-lg dark:border-amber-700 dark:bg-amber-950/90 dark:text-amber-100">
        <div>
          <p class="font-semibold">
            @switch (accessIssue()) {
              @case ('no-tenants') { Tu usuario no tiene tenants asignados en este ambiente. }
              @case ('access') { No fue posible cargar el menú y los permisos. }
              @default { No fue posible cargar tu sesión de Paybridge. }
            }
          </p>
          <p class="mt-0.5 opacity-80">
            @if (accessIssue() === 'no-tenants') {
              Solicita al administrador que asocie tu cuenta a un tenant.
            } @else {
              Puedes reintentar sin cerrar la sesión.
            }
          </p>
        </div>
        @if (accessIssue() !== 'no-tenants') {
          <button
            type="button"
            class="btn btn-sm shrink-0 border-amber-400 bg-white text-amber-950 hover:bg-amber-100 dark:bg-amber-900 dark:text-amber-50"
            [disabled]="accessLoading()"
            (click)="retryAccessContext()"
          >
            {{ accessLoading() ? 'Cargando…' : 'Reintentar' }}
          </button>
        }
      </div>
    }

    <!-- Page content -->
    <main
      class="flex flex-1 items-stretch justify-start overflow-y-auto bg-[#f5f6f7] p-4 dark:bg-(--bg-app) scrollbar-gutter-stable [&>*:not(router-outlet)]:pb-4"
    >
      @if (accessReady()) {
        <router-outlet />
      } @else if (accessLoading()) {
        <div class="flex min-h-[240px] w-full items-center justify-center text-sm text-gray-500 dark:text-(--text-secondary)" role="status">
          Cargando contexto del tenant…
        </div>
      }
    </main>

  </div>

  @defer (on idle) {
    <app-ingestion-progress />
  }
</div>

